/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/**
 * 
 * @export
 * @enum {string}
 */
export enum IdeaVisibility {
    Public = 'Public',
    Private = 'Private'
}

export function IdeaVisibilityFromJSON(json: any): IdeaVisibility {
    return json as IdeaVisibility;
}

export function IdeaVisibilityToJSON(value?: IdeaVisibility): any {
    return value as any;
}

